import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const GetAllCourseConfigs = () => {
  const url = apiConstants.GetAllCourseConfigs;

  return httpClient.get(url).then(result => result.data.result.items);
};

const GetCourseConfig = (id) => {
  const url = `${apiConstants.GetCourseConfig}?Id=${id}`;

  return httpClient.get(url).then(result => result.data.result.items);
};

const GetCourseConfigById = (id) => {
  const url = `${apiConstants.GetAllCourseConfigs}?Keyword=${id}&SkipCount=0&MaxResultCount=100000`;

  return httpClient.get(url).then(result => result.data.result.items[0]);
};

export { GetAllCourseConfigs, GetCourseConfig, GetCourseConfigById };
